import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=daae34aa&lang=pug&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports